/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VenuesIndexRouteImport } from './routes/venues/index'
import { Route as OrganisationsIndexRouteImport } from './routes/organisations/index'
import { Route as AgenciesIndexRouteImport } from './routes/agencies/index'
import { Route as AdminsIndexRouteImport } from './routes/admins/index'
import { Route as VenuesVenueIdRouteImport } from './routes/venues/$venueId'
import { Route as OrganisationsOrganisationIdRouteImport } from './routes/organisations/$organisationId'
import { Route as AgenciesAgencyIdRouteImport } from './routes/agencies/$agencyId'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuesIndexRoute = VenuesIndexRouteImport.update({
  id: '/venues/',
  path: '/venues/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisationsIndexRoute = OrganisationsIndexRouteImport.update({
  id: '/organisations/',
  path: '/organisations/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgenciesIndexRoute = AgenciesIndexRouteImport.update({
  id: '/agencies/',
  path: '/agencies/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminsIndexRoute = AdminsIndexRouteImport.update({
  id: '/admins/',
  path: '/admins/',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuesVenueIdRoute = VenuesVenueIdRouteImport.update({
  id: '/venues/$venueId',
  path: '/venues/$venueId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisationsOrganisationIdRoute =
  OrganisationsOrganisationIdRouteImport.update({
    id: '/organisations/$organisationId',
    path: '/organisations/$organisationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AgenciesAgencyIdRoute = AgenciesAgencyIdRouteImport.update({
  id: '/agencies/$agencyId',
  path: '/agencies/$agencyId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/agencies/$agencyId': typeof AgenciesAgencyIdRoute
  '/organisations/$organisationId': typeof OrganisationsOrganisationIdRoute
  '/venues/$venueId': typeof VenuesVenueIdRoute
  '/admins/': typeof AdminsIndexRoute
  '/agencies/': typeof AgenciesIndexRoute
  '/organisations/': typeof OrganisationsIndexRoute
  '/venues/': typeof VenuesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/agencies/$agencyId': typeof AgenciesAgencyIdRoute
  '/organisations/$organisationId': typeof OrganisationsOrganisationIdRoute
  '/venues/$venueId': typeof VenuesVenueIdRoute
  '/admins': typeof AdminsIndexRoute
  '/agencies': typeof AgenciesIndexRoute
  '/organisations': typeof OrganisationsIndexRoute
  '/venues': typeof VenuesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/agencies/$agencyId': typeof AgenciesAgencyIdRoute
  '/organisations/$organisationId': typeof OrganisationsOrganisationIdRoute
  '/venues/$venueId': typeof VenuesVenueIdRoute
  '/admins/': typeof AdminsIndexRoute
  '/agencies/': typeof AgenciesIndexRoute
  '/organisations/': typeof OrganisationsIndexRoute
  '/venues/': typeof VenuesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/agencies/$agencyId'
    | '/organisations/$organisationId'
    | '/venues/$venueId'
    | '/admins/'
    | '/agencies/'
    | '/organisations/'
    | '/venues/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/agencies/$agencyId'
    | '/organisations/$organisationId'
    | '/venues/$venueId'
    | '/admins'
    | '/agencies'
    | '/organisations'
    | '/venues'
  id:
    | '__root__'
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/agencies/$agencyId'
    | '/organisations/$organisationId'
    | '/venues/$venueId'
    | '/admins/'
    | '/agencies/'
    | '/organisations/'
    | '/venues/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  AgenciesAgencyIdRoute: typeof AgenciesAgencyIdRoute
  OrganisationsOrganisationIdRoute: typeof OrganisationsOrganisationIdRoute
  VenuesVenueIdRoute: typeof VenuesVenueIdRoute
  AdminsIndexRoute: typeof AdminsIndexRoute
  AgenciesIndexRoute: typeof AgenciesIndexRoute
  OrganisationsIndexRoute: typeof OrganisationsIndexRoute
  VenuesIndexRoute: typeof VenuesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venues/': {
      id: '/venues/'
      path: '/venues'
      fullPath: '/venues/'
      preLoaderRoute: typeof VenuesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisations/': {
      id: '/organisations/'
      path: '/organisations'
      fullPath: '/organisations/'
      preLoaderRoute: typeof OrganisationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agencies/': {
      id: '/agencies/'
      path: '/agencies'
      fullPath: '/agencies/'
      preLoaderRoute: typeof AgenciesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admins/': {
      id: '/admins/'
      path: '/admins'
      fullPath: '/admins/'
      preLoaderRoute: typeof AdminsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venues/$venueId': {
      id: '/venues/$venueId'
      path: '/venues/$venueId'
      fullPath: '/venues/$venueId'
      preLoaderRoute: typeof VenuesVenueIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisations/$organisationId': {
      id: '/organisations/$organisationId'
      path: '/organisations/$organisationId'
      fullPath: '/organisations/$organisationId'
      preLoaderRoute: typeof OrganisationsOrganisationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agencies/$agencyId': {
      id: '/agencies/$agencyId'
      path: '/agencies/$agencyId'
      fullPath: '/agencies/$agencyId'
      preLoaderRoute: typeof AgenciesAgencyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  AgenciesAgencyIdRoute: AgenciesAgencyIdRoute,
  OrganisationsOrganisationIdRoute: OrganisationsOrganisationIdRoute,
  VenuesVenueIdRoute: VenuesVenueIdRoute,
  AdminsIndexRoute: AdminsIndexRoute,
  AgenciesIndexRoute: AgenciesIndexRoute,
  OrganisationsIndexRoute: OrganisationsIndexRoute,
  VenuesIndexRoute: VenuesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
